const GRAMS_PER_GEL = 25;

export function calculateGelsPerHour(absorptionGPerHour: number): number {
  return Math.round((absorptionGPerHour / GRAMS_PER_GEL) * 10) / 10;
}
